"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.register", {
		url: "/register",
		controller: "RegisterController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/register/register.template.html"
	});
}]);
